import React, { useCallback } from 'react';
import { Table, Typography } from 'antd';

import { useSalesRegion } from '@hooks/SalesRegionContext';
import TableFilters from '@components/TableFilters';
import { SearchOutlined } from '@ant-design/icons';
import '../../styles.css';
const { Text } = Typography;

interface CitiesTableProps {
  showModal: Function;
  representativeCode: number;
}
const CitiesTable: React.FC<CitiesTableProps> = ({ showModal, representativeCode }) => {
  const { operationalArea, loadSalesRegionsCustomers } = useSalesRegion();

  const handleCustomersModal = useCallback(
    (cityCode: string) => {
      loadSalesRegionsCustomers(representativeCode, { cityCode });
      showModal();
    },
    [showModal, loadSalesRegionsCustomers, representativeCode],
  );

  const columnsCities = [
    {
      title: 'Cidade',
      dataIndex: 'cityName',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pela Cidade'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.cityName ? record.cityName.toString().toLowerCase().includes(value.toLowerCase()) : '';
      },
    },
    {
      render: (record: any) => (
        <Text
          style={{ color: 'var(--primary-color)', fontWeight: 'bold', cursor: 'pointer' }}
          onClick={() => handleCustomersModal(record.cityCode)}
        >
          Ver clientes
        </Text>
      ),
      align: 'right' as 'right',
    },
  ];

  return (
    <>
      {operationalArea.operationalAreaCities?.length > 0 && (
        <Table
          className="mt-8 custom-table"
          columns={columnsCities}
          dataSource={operationalArea.operationalAreaCities}
          pagination={{ showSizeChanger: false, style: { marginTop: '24px' }, hideOnSinglePage: false }}
          scroll={{ x: 800 }}
        />
      )}
    </>
  );
};

export default CitiesTable;
